import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import ProductLicense from './ProductLicense'

function ProductPriceFree({
  id, license, title, licenseText,
}) {
  const downloadPath = `/items/${id}/download-page`

  return (
    <div itemProp="offers" itemScope="" itemType="http://schema.org/Offer" className="container-fixed">
      <meta itemProp="priceCurrency" content="USD" />

      <div className="col-12">
        <div className="sticky-container">
          <div className="sticky-price-bar__title">
            {title}
          </div>
          <div className="sticky-price-bar__price">
            <div className="product-pricing__price-row">
              <div className="product-pricing__price" itemProp="price">
                Free
              </div>
            </div>

            <ProductLicense {...license} licenseText={licenseText} />

            <div className="product-pricing__buy-buttons">
              <a className="btn btn-secondary btn-block" href={downloadPath}>
                <Icon type={['far', 'download']} />
                Free download
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ProductPriceFree.propTypes = {
  id: PropTypes.string.isRequired,
  license: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
}

export default ProductPriceFree
